import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { listChars } from '../../services/chars';
import { charactersActions, authActions, configActions } from '../../redux/actions';

import { Container, CharRow } from './StreamLink.styles';

export default () => {

    const [font, setFont] = useState('Roboto');

    const routerParams = useParams();
    const routerLocation = useLocation();
    const dispatch = useDispatch();
    const token = useSelector(state => state.authState.token);

    const characters = useSelector(state => state.charactersState.characters);

    useEffect(() => {
        dispatch(authActions.login({
            token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0cmVhbWxpbmtAaHVicnBnLmNvbSIsImlkIjoic3RyZWFtbGluayIsImlhdCI6MTY1MjQxNDQyNH0.IZGe0rVUek3Tn1gEb_IylcgnoggqIqYzjqqox1HfxjE",
            email: "streamlink@hubrpg.com",
            id: "streamlink",
            name: "streamlink",
            color: "#000000"
        }));
    }, [dispatch]);

    useEffect(() => {
        const parsed = queryString.parse(routerLocation.search);
        const font = parsed && parsed.font ? parsed.font : 'Roboto';
        setFont(font);
    }, [routerLocation]);

    useEffect(() => {
        (async () => {
            if (!token) {
                return;
            }

            try {
                let chars = await listChars(routerParams.id);
                dispatch(charactersActions.setCharacters(chars && chars.length ? chars : []));
            } catch(e) {
                console.log(e);
            }
        })();
    }, [dispatch, routerParams, token]);

    useEffect(() => {
        dispatch(configActions.setTableId(routerParams.id));
    }, [routerParams.id]);

    return <Container>
        {characters && characters.length ? characters.filter(c => c.player).map(c => <CharRow key={c.id} font={font}>
            <div>{c.name}</div>
            <div>{c.dataset ? c.dataset.redCurrent || "0" : "0"}/{c.dataset ? c.dataset.redMax || "0" : "0"}</div>
            <div>{c.dataset ? c.dataset.greenCurrent || "0" : "0"}/{c.dataset ? c.dataset.greenMax || "0" : "0"}</div>
            <div>{c.dataset ? c.dataset.blueCurrent || "0" : "0"}/{c.dataset ? c.dataset.blueMax || "0" : "0"}</div>
        </CharRow>) : null}
    </Container>
};